"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var secp256k1_1 = require("secp256k1");

var buffer_1 = require("./buffer");

var hex_1 = require("./hex");

var keccak_1 = require("./keccak");

var secp256k1_2 = require("./secp256k1");

function hashPersonalMessage(message) {
  var hex = hex_1.toHex(message);
  var size = hex_1.getHexBytesSize(hex);
  return keccak_1.keccak256("\x19Ethereum Signed Message:\n".concat(size), hex);
}

exports.hashPersonalMessage = hashPersonalMessage;

function signPersonalMessage(message, privateKey) {
  var messageHash = hashPersonalMessage(message);

  var _secp256k1_1$sign = secp256k1_1.sign(buffer_1.toBuffer(messageHash), buffer_1.toBuffer(privateKey)),
      recovery = _secp256k1_1$sign.recovery,
      signature = _secp256k1_1$sign.signature;

  return hex_1.concatHex(signature, hex_1.padHexLeft(recovery, 1));
}

exports.signPersonalMessage = signPersonalMessage;

function recoverPublicKeyFromPersonalMessage(message, signature) {
  var hash = hashPersonalMessage(message);
  var signatureBuff = buffer_1.toBuffer(signature);
  var s = signatureBuff.slice(0, -1);
  var r = signatureBuff[signatureBuff.length - 1];
  var result = null;

  try {
    var publicKey = hex_1.toHex(secp256k1_1.recover(buffer_1.toBuffer(hash), s, r, false));
    result = secp256k1_2.verifyPublicKey(publicKey) ? publicKey : null;
  } catch (err) {
    result = null;
  }

  return result;
}

exports.recoverPublicKeyFromPersonalMessage = recoverPublicKeyFromPersonalMessage;

function recoverAddressFromPersonalMessage(message, signature) {
  var publicKey = recoverPublicKeyFromPersonalMessage(message, signature);
  return publicKey ? secp256k1_2.publicKeyToAddress(publicKey) : null;
}

exports.recoverAddressFromPersonalMessage = recoverAddressFromPersonalMessage;